import React, { memo } from "react";
import PT from "prop-types";
import Service from "../Service";
import Accordion from "_c/Accordion";
import DraggableServices from "./DraggableServices";

const Section = ({
  services,
  spec,
  masterId,
  isOwner,
  addToBasket,
  removeFromBasket,
  openEditor,
}) => {
  const serviceProps = {
    masterId: masterId,
    addToBasket: addToBasket,
    removeFromBasket: removeFromBasket,
    openEditor: openEditor,
    isOwner: isOwner,
  };
  const isDraggable = isOwner && services.length > 1;
  return (
    <div
      css={`
        margin-bottom: 15px;
      `}
    >
      <Accordion defaultOpen title={spec.title}>
        {isDraggable ? (
          <DraggableServices
            services={services}
            serviceBaseProps={serviceProps}
          />
        ) : (
          <>
            {services.map((service) => (
              <Service {...serviceProps} key={service._id} service={service} />
            ))}
          </>
        )}
      </Accordion>
    </div>
  );
};
Section.propTypes = {
  spec: PT.object,
  services: PT.arrayOf(PT.object),
  isOwner: PT.bool,
  userId: PT.string,
  masterId: PT.string.isRequired,

  openEditor: PT.func.isRequired,
};
Section.displayName = "ServicesSection";

export default memo(Section);
